import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate} from "react-router-dom";
import Swal from 'sweetalert2';

import helpers from '../../helpers/helpers';
import images from '../../helpers/images';
import appConfig from '../../config/env';
import { httpRequest } from '../../helpers/httpService';
import appSession from '../../helpers/session';
import Loader from './Loader';
import store from '../../helpers/store';


import RenderErrors from '../elements/RenderErrors';
import InputText from '../elements/InputText';
import InputNumber from '../elements/InputNumber';
import DropDownSelection from '../elements/DropDownSelection';

function RegistrationForm({title = '', redirect_to = '/'}){
    let { event_id } = useParams();
    const [errors, setErrors] = useState([]);
    
    const [registration_data, setLogin] = useState({
        first_name: '',
        last_name: '',
        email: '',
        mobile_no: '',
        gender: '',
        birth_date: ''
    });

    const [loading, setLoading] = useState(0);

    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        let new_state = { [name]: value }

        setLogin({ ...registration_data, ...new_state });
    }

    function removeErrors(e){
        let { name } = e.target;
        let newErrors = {...errors}

        delete newErrors[name];

        setErrors(newErrors);
    }

    function handleRegister(type = ''){
        let form_data = {...registration_data};
        form_data.login_type = type;

        const url = appConfig.apiUrl + '/account/register';

        setLoading(1)

        httpRequest(url, "POST", {
            postdata: { 
                ...form_data, 
            },
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                let message = '';
                if(res.message){
                    message = res.message
                }

                Swal.fire({
                    title: "Success!",
                    text: message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
            })
            .catch((err) => {
                setLoading(0)

                if(err.data){
                    setErrors( err.data );
                    err.message = "Please check your entry";
                }
      
                Swal.fire({
                    title: 'Error!',
                    text: err.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            });
    }
    
    return (
        <form action="/" method="post">
            <Loader isLoading={loading}/>

            <div className="container px-2">
                <h4 className="faith-login-title mt-3 px-2">Create Account</h4>
                <div className="row px-3">
                    <div className="col-12 col-md-6 mb-3">
                        <InputText
                            id="first_name" 
                            name="first_name"  
                            value={registration_data.first_name}    
                            label={<>First Name <span className="text-danger">*</span></>}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            onFocus={removeErrors}
                            //onChange={(e) => setLoginEmail(e.target.value)}
                            placeholder='Your first name here'
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="first_name" 
                            className="text-danger fs-7"
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <InputText
                            id="last_name" 
                            name="last_name"  
                            value={registration_data.last_name}    
                            label={<>Last Name <span className="text-danger">*</span></>}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            onFocus={removeErrors}
                            //onChange={(e) => setLoginEmail(e.target.value)}
                            placeholder='Your last name here'
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="last_name" 
                            className="text-danger fs-7"
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <InputText
                            id="email" 
                            name="email"  
                            value={registration_data.email}    
                            label={<>Email <span className="text-danger">*</span></>}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            onFocus={removeErrors}
                            type="email"
                            //onChange={(e) => setLoginEmail(e.target.value)}
                            placeholder='Your email address here'
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="email" 
                            className="text-danger fs-7"
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <InputNumber
                            label="Mobile Number"
                            id="mobile_no" 
                            name="mobile_no" 
                            value={registration_data.mobile_no}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            onFocus={removeErrors}
                            placeholder='Your mobile number here'
                        /> 
                        <RenderErrors 
                            errors={errors} 
                            name="mobile_no" 
                            className="text-danger fs-7"
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <DropDownSelection
                            label="Gender"
                            tagClass="form-control mb-0"
                            name="gender"
                            id="gender"
                            placeholder="Select Gender" 
                            value={registration_data.gender}  
                            onChange={inputChange}
                            onFocus={removeErrors}
                            optionList={store.gender}
                            optionProps ={{value:'id', label:'label'}}
                        /> 
                        <RenderErrors 
                            errors={errors} 
                            name="gender" 
                            className="text-danger fs-7"
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <InputText
                            label="Birth Date"
                            id="birth_date" 
                            name="birth_date" 
                            value={registration_data.birth_date}    
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            placeholder="Your Birth Date"
                            onFocus={removeErrors}
                            type="date"
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="birth_date" 
                            className="text-danger fs-7"
                        />
                    </div>
                    <div className="container d-flex justify-content-end">
                        <button type="button" className="cancelbtn"  onClick={(e) => handleRegister('user')}>Register</button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default RegistrationForm;